import React from 'react';
import './Calendar.css';

const Calendar = () => {
  return (
    <main className="calendar-page page">
      <div className="page-container">
        <h1>Academic Calendar 2026-27</h1>
        <div className="calendar-intro">
          <p>
            Welcome to the academic calendar for the 2026-27 session. You can view the full schedule below 
            or download a copy for your reference.
          </p>
        </div>
        
        <div className="pdf-container">
          <iframe 
            src={`${process.env.PUBLIC_URL}/pdfs/YEAR_CALENDAR_2026-27.pdf`} 
            title="Academic Calendar 2026-27"
            className="pdf-viewer"
          />
        </div>
        
        <div className="download-section">
          <a 
            href={`${process.env.PUBLIC_URL}/pdfs/YEAR_CALENDAR_2026-27.pdf`} 
            download="YEAR_CALENDAR_2026-27.pdf"
            className="download-btn"
          >
            Download Calendar (PDF)
          </a>
        </div>
      </div>
    </main>
  );
};

export default Calendar;
